import { NotificationManager } from 'react-notifications';
import Sentry from 'Integrations/Sentry';
import fr from 'facet-rest';

export default class FacetNotificationManager {}

function getStatusFromError(err) {
  if (err?.status !== undefined) {
    return err.status;
  }

  if (err?.response !== undefined) {
    return err.response.status;
  }

  return undefined;
}

/**
 * @deprecated - Use displayErrorMessage from useSnackbarContext
 */
export const displayErrorMessage = (
  error,
  msg,
  title,
  timeOut,
  onClick,
  priority,
) => {
  // Show maintainence page when down in dev
  if (error.message?.includes('Request has been terminated') || error.message?.includes('Down for maintenance') || error?.status === 503) {
    return fr.config.onError(error);
  }
  // If the error passed in is an array of errors, parse each one and concatinate into one message.
  // Note:  This will assume that the structure of the errors in the array will be { detail:'', ?shortDetail:''},
  //        which from my (Matt Holdefer) inspection of the code seems to be the case.
  if (Array.isArray(msg)) {
    NotificationManager.error(
      Sentry.createErrorMessage(msg),
      title,
      timeOut,
      onClick,
      priority,
    );
  } else if (msg) {
    NotificationManager.error(msg, title, timeOut, onClick, priority);
  }

  const status = getStatusFromError(error);

  console.log('Error: ', error); // eslint-disable-line
  Sentry.createSentryErrorLog(error, status);

  return null;
};

export const displaySuccess = (message, timeout) => {
  NotificationManager.success(message, null, timeout);
};

export const displayInfo = (message, timeout) => {
  NotificationManager.info(message, null, timeout);
};
